import { render, staticRenderFns } from "./MySupportTicketPreview.vue?vue&type=template&id=61c10017&scoped=true"
import script from "./MySupportTicketPreview.vue?vue&type=script&lang=js"
export * from "./MySupportTicketPreview.vue?vue&type=script&lang=js"
import style0 from "./MySupportTicketPreview.vue?vue&type=style&index=0&id=61c10017&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c10017",
  null
  
)

export default component.exports